module.exports = __webpack_public_path__ + "img/look_system_device.a3406972.png";